import React from 'react';
import { Component } from 'react';
import { FinalAsktheExpertScreenJSX } from './finalAskTheExpertScreen.jsx';

export default class FinalCustomerAskTheExpertScreen extends Component {
    onHomebuttonClick = () => {
        localStorage.clear('askTheExpert')
        this.props.history.push('/customerAskTheExpert');
    }

    render() {
        return (
            <FinalAsktheExpertScreenJSX
                onHomebuttonClick={this.onHomebuttonClick}
            />
        )
    }
}